"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAutoGeneratedComment = exports.formatCurrencyNumber = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const numeral_1 = __importDefault(require("numeral"));
const currencies_1 = require("../consts/currencies");
const autoGeneratedComments_enum_1 = require("../models/comment/autoGeneratedComments.enum");
const currency_enum_1 = require("../models/common/currency.enum");
const userSettings_interface_1 = require("../models/user/userSettings.interface");
/**
 * To be able to use numeral.locale("de")
 *
 * See: https://github.com/adamwdraper/Numeral-js/issues/548
 *
 * TODO: replace numberaljs - project is most likely abandonned
 */
require("numeral/locales/de");
exports.formatCurrencyNumber = (value, currency, showFullNumber = false, decimalPrecision = 2, maxDigits = 8, localeData) => {
    var _a;
    // convert between locale if necessary
    if (localeData && localeData.localeFrom !== localeData.localeTo) {
        numeral_1.default.locale(localeData.localeFrom);
        const numeralValue = numeral_1.default(value);
        numeral_1.default.locale(localeData.localeTo);
        value = numeralValue.value();
    }
    // To avoid too much digit count on number such as 21.00000003
    const testString = numeral_1.default(value).format('00');
    const decimalFormatter = '0'.repeat(decimalPrecision);
    const formatString = showFullNumber || testString.length <= maxDigits ? `0,0${decimalPrecision && `.${decimalFormatter}`}` : `0,0${decimalPrecision && `[.]${decimalFormatter}a`}`;
    const formattedValue = numeral_1.default(value).format(formatString);
    const prefix = currency === currency_enum_1.CurrencyEnum.USD ? '$ ' : '';
    const suffix = currency !== currency_enum_1.CurrencyEnum.USD ? ` ${(_a = currencies_1.Currencies[currency]) === null || _a === void 0 ? void 0 : _a.symbol}` : '';
    return `${prefix}${formattedValue}${suffix}`;
};
/*
 For auto generated comments, the comment message saved in the db has the following structure: "message,extra". Extra can be a string or a link.
    The differentiation is done in the locales json file.
    e.g
    - to interpolate a string: "has sent out a reminder to {{extra}} (Approver)."
    - to interpolate a link: "has matched the request to <0>this transaction</0>."
        <0> -> 0 is the index of the component in the components array in <Trans ... />
 */
exports.parseAutoGeneratedComment = (message, userLanguage) => {
    const commentTokens = message.split(',');
    const commentMessage = commentTokens[0];
    const commentExtra = commentTokens.length > 2 ? commentTokens.slice(1, commentTokens.length) : commentTokens[1];
    const values = {};
    if (commentTokens.length === 2)
        values.extra = commentTokens[1];
    else {
        // Special case that handles rejection notes in the form: `Sure, that the cost center is right?` (notes containing ",")
        // as well as filenames containing ","
        if (commentMessage === 'request.rejection_note' || commentMessage === 'request.invoice_uploaded_with_filename') {
            let currentExtra = '';
            for (let i = 1; i < commentTokens.length; i++) {
                currentExtra += i !== commentTokens.length - 1 ? `${commentTokens[i]}, ` : `${commentTokens[i]}`; // "Revert" the "," unless it is the last chunk/part of the original note
            }
            values.extra = currentExtra;
        }
        for (let i = 1; i <= commentTokens.length; i++) {
            values[`extra${i}`] = commentTokens[i];
        }
    }
    // special cases
    if (commentMessage === 'request.gross_amount_changed_due_to_transaction') {
        const currency = values.extra3;
        // since comments are all stored in EN, we gotta convert the numbers if needed
        const localeData = { localeFrom: userSettings_interface_1.UserLanguageEnum.EN, localeTo: userLanguage };
        values.extra1 = exports.formatCurrencyNumber(values.extra1, currency, true, 2, 8, localeData);
        values.extra2 = exports.formatCurrencyNumber(values.extra2, currency, true, 2, 8, localeData);
    }
    else if (commentMessage === autoGeneratedComments_enum_1.AutoGeneratedCommentsEnum.INBOX_INVOICE_ATTACHED_WITH_FILENAME_AND_UPLOAD_DATE) {
        // format the date
        values.extra2 = moment_timezone_1.default(values.extra2).format('DD.MM.YYYY');
    }
    return { commentMessage, values, commentExtra };
};
